module.exports = require('./lit-html')
